import { IFsMap } from '@lib/geo/core';

import { Maps } from '../utils';

// Use duck typing to avoid circular dependencies
export const isEsriMap = (map: IFsMap | any): boolean => {
  return map && (map.geospatialProvider === Maps.ESRI || (map.mapView && map.sceneView));
};

export const isGoogleMap = (map: IFsMap | any): boolean => {
  return (
    map && (map.geospatialProvider === Maps.GOOGLE || (map.mapInstance && map.mapInstance.getBounds))
  );
};
